import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { create } from "@mui/material/styles/createTransitions";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

export default function StockCountModal(props) {
  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_APP_URL;
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  const [branchID, setBranchID] = useState("");
  const [itemID, setItemID] = useState("");
  const [unitID, setUnitID] = useState("");
  const [curQTY, setCurQTY] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [reorder, setReorder] = useState("");
  const [unit, setUnit] = useState([]);
  const [items, setItems] = useState([]);
  const [showUnit, setShowUnit] = useState(false);
  const [con, setCon] = useState("");
  const [totalUnit, setTotalUnit] = useState("");

  const handleCalculation = async () => {
    if (con === "PU") {
      api.get("procedure-item/" + itemID).then((res) => {
        setFrom(res.data.data[0].fromUnit);
        setTo(res.data.data[0].toUnit);
      });
    }
    if (con === "MU") {
      api.get("medicine-item/" + itemID).then((res) => {
        setFrom(res.data.data[0].fromUnit);
        setTo(res.data.data[0].toUnit);
      });
    }
    if (con === "AU") {
      api.get("accessory-item/" + itemID).then((res) => {
        setFrom(res.data.data[0].fromUnit);
        setTo(res.data.data[0].toUnit);
      });
    }
    console.log("totalUnit", (curQTY * to) / from);
    console.log();
    setTotalUnit((curQTY * to) / from);
  };

  const createStock = async () => {
    let data = {
      relatedBranch: branchID,
      currentQty: curQTY,
    };
    if (con === "PU") {
      data.relatedProcedureItems = itemID;
      api.get("procedure-item/" + itemID).then((res) => {
        setFrom(res.data.data[0].fromUnit);
        setTo(res.data.data[0].toUnit);
      });
    }
    if (con === "MU") {
      data.relatedMedicineItems = itemID;
      api.get("medicine-item/" + itemID).then((res) => {
        setFrom(res.data.data[0].fromUnit);
        setTo(res.data.data[0].toUnit);
      });
    }
    if (con === "AU") {
      data.relatedAccessoryItems = itemID;
      api.get("accessory-item/" + itemID).then((res) => {
        setFrom(res.data.data[0].fromUnit);
        setTo(res.data.data[0].toUnit);
      });
    }
    let totalUnit = (curQTY * to) / from;
    data = { ...data, fromUnit: from, toUnit: to, totalUnit: totalUnit };
    api.post("stock", data).then((res) => {
      props.setOpen(false);
      Swal.fire({
        title: "Successful!",
        text: "Successfully Created Stock Entry!",
        icon: "success",
        cancelButtonText: "Close",
      });
    });
  };

  const handleCategory = async (e) => {
    if (e === "PU") {
      getProcedureUnit();
    } else if (e === "MU") {
      getMedicineUnit();
    } else if (e === "AU") {
      getAccessoryUnit();
    }
    setShowUnit(true);
    setCon(e);
  };
  const getItems = async (id) => {
    if (con === "PU") {
      api.get("procedure-items/" + id).then((res) => {
        setItems(res.data.data);
        console.log(res.data.data, "getITEMS");
      });
    } else if (con === "MU") {
      api.get("medicine-items/" + id).then((res) => {
        setItems(res.data.data);
        console.log(res.data.data, "getITEMS");
      });
    } else if (con === "AU") {
      api.get("accessory-items/" + id).then((res) => {
        setItems(res.data.data);
        console.log(res.data.data, "getITEMS");
      });
    }

    console.log(items, "items");
  };

  const getProcedureUnit = async () => {
    api.get("procedure-medicines").then((res) => {
      setUnit(res.data.list);
      console.log(res.data.list);
    });
  };
  const getMedicineUnit = async () => {
    api.get("medicine-lists").then((res) => {
      setUnit(res.data.list);
      console.log(res.data.list);
    });
  };
  const getAccessoryUnit = async () => {
    api.get("procedure-accessories").then((res) => {
      setUnit(res.data.list);
      console.log(res.data.list);
    });
  };
  return (
    <div>
      <Dialog open={props.open} onClose={props.close}>
        <DialogTitle>
          {" "}
          <div className="modal-header">
            <h4 className="modal-title">Stock Entry</h4>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.close}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </DialogTitle>
        <DialogContent style={{ width: "500px" }}>
          <DialogContentText></DialogContentText>

          <div className="row">
            <div className="form-group">
              <label className="control-label">Branch</label>

              <select
                name="branch"
                id=""
                className="form-control mt-1"
                onchange="convert(this.value)"
                onChange={(e) => setBranchID(e.target.value)}
              >
                <option value="">Choose Branch</option>

                {props.branchesLists.map((option) => (
                  <option value={option._id}>{option.name}</option>
                ))}
              </select>
              {console.log(branchID, "BRANCHID")}
            </div>
          </div>
          <div className="row">
            <div className="form-group">
              <label className="control-label">Category</label>

              <select
                name="currency"
                id=""
                className="form-control mt-1"
                onchange="convert(this.value)"
                onChange={(e) => handleCategory(e.target.value)}
              >
                <option value="">Choose Category</option>
                <option value="MU">Medicine Unit</option>
                <option value="PU">Procedure Unit</option>
                <option value="AU">Accessory Unit</option>
              </select>
              {console.log(branchID, "BRANCHID")}
            </div>
          </div>

          {showUnit ? (
            <>
              <div className="row">
                <div className="form-group">
                  <label className="control-label">Unit</label>

                  <select
                    name="currency"
                    id=""
                    className="form-control mt-1"
                    onchange="convert(this.value)"
                    onChange={(e) => getItems(e.target.value)}
                  >
                    <option value="">Choose Unit</option>
                    {unit.map((option) => (
                      <option value={option._id}>{option.name}</option>
                    ))}
                  </select>
                  {console.log(unitID, "UNITID")}
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          <div className="row">
            <div className="form-group">
              <label className="control-label">Items</label>

              <select
                name="currency"
                id=""
                className="form-control mt-1"
                onchange="convert(this.value)"
                onChange={(e) => {
                  setItemID(e.target.value);
                }}
              >
                <option value="">Choose Items</option>
                {items.map((option) => (
                  <option value={option._id}>
                    {option.procedureItemName
                      ? option.procedureItemName
                      : option.medicineItemName
                        ? option.medicineItemName
                        : option.accessoryItemName
                          ? option.accessoryItemName
                          : ""}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="row">
            <div className="form-group">
              <label className="control-label">Current QTY</label>
              <input
                type="number"
                className="form-control"
                name="amount"
                id="finalamount"
                onChange={(e) => {
                  setCurQTY(e.target.value);
                }}
              />
            </div>
          </div>
          {/* <div className='row'>
                        <div className='form-group'>
                            <label className='control-label'>From Unit</label>
                            <input
                                type='number'
                                className='form-control'
                                name='amount'
                                id='finalamount'
                                defaultValue={from}

                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='form-group'>
                            <label className='control-label'>To Unit</label>
                            <input
                                type='number'
                                className='form-control'
                                name='amount'
                                id='finalamount'
                                defaultValue={to}

                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='form-group'>
                            <label className='control-label'>Total Unit</label>
                            <input
                                type='number'
                                className='form-control'
                                name='amount'
                                id='finalamount'
                                defaultValue={totalUnit}
                            />
                        </div>
                    </div> */}

          <div className="row">
            <div className="col-md-9 mt-4">
              <button
                type="submit"
                className="btn btn-success"
                onClick={() => createStock()}
              >
                Submit
              </button>
              <button
                type="button"
                className="btn btn-inverse btn-dismiss"
                data-dismiss="modal"
                onClick={props.close}
              >
                Cancel
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
